import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownTimerProps {
  variant?: 'light' | 'dark' | 'red';
}
export const CountdownTimer: React.FC<CountdownTimerProps> = ({
  variant = 'dark'
}) => {
  const {
    minutes,
    seconds
  } = useCountdown();
  const getBgColor = () => {
    switch (variant) {
      case 'light':
        return 'bg-white text-gray-900';
      case 'red':
        return 'bg-white text-red-600';
      default:
        return 'bg-red-600 text-white';
    }
  };
  return <div className="flex items-center gap-2 font-bold" data-id="element-50">
      <div className={`flex items-center justify-center w-10 h-10 rounded-lg text-lg ${getBgColor()}`} data-id="element-51">
        {minutes}
      </div>
      <span className={variant === 'light' ? 'text-white' : 'text-gray-800'} data-id="element-52">
        :
      </span>
      <div className={`flex items-center justify-center w-10 h-10 rounded-lg text-lg ${getBgColor()}`} data-id="element-53">
        {seconds}
      </div>
    </div>;
};